import styled from 'styled-components'

const Bound = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    /* background-color: red; */
`

export { Bound }